import React, { useState, useEffect, useRef } from "react";
import { SudoButton } from "src/sudokit/components/SudoButton";
import { useProjectStore } from "src/stores/projectStore";
import { DRAFT_PROGRESS_LABELS, DRAFT_PROGRESS_LABEL_MS } from "../draftProgressLabels";

const GenerateScenesLoaderButton = ({ requesting, outOfQuota, disabled, onClick }) => {
  const labels = [...DRAFT_PROGRESS_LABELS];
  const [label, setLabel] = useState(labels[0]);
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const animationStartTimeRef = useRef(Date.now());
  const animationDuration = 36000; // 30 seconds
  const targetPercentage = 90;

  const document = useProjectStore((state) => state.document);

  useEffect(() => {
    // Adds an additional label if a document has previous documents linked to it
    const chapterLabel = document?.previousDocumentsCount > 1 ? "Checking Previous Chapters..." : "Checking Previous Chapter...";
    const insertIndex = labels.indexOf("Checking Synopsis and Outline...");

    if (document?.previousDocumentsCount > 0 && !labels.includes(chapterLabel)) {
      labels.splice(insertIndex, 0, chapterLabel);
    } else if (document?.previousDocumentsCount === 0) {
      const index = labels.indexOf(chapterLabel);
      if (index !== -1) {
        labels.splice(index, 1);
      }
    }
  }, [document]);

  // Single effect to handle both animations with independent timing
  useEffect(() => {
    // Effect for label rotation - every 6.5 seconds
    const labelInterval = setInterval(() => {
      setLabel((prevLabel) => {
        const currentIndex = labels.indexOf(prevLabel);
        // If we're at the last label, stay there
        if (currentIndex === labels.length - 1) {
          return prevLabel;
        }
        // Otherwise, move to the next label
        return labels[currentIndex + 1];
      });
    }, DRAFT_PROGRESS_LABEL_MS);

    // Effect for loading animation - update every 100ms for smooth animation
    const loadingInterval = setInterval(() => {
      const elapsedTime = Date.now() - animationStartTimeRef.current;
      const progress = Math.min(elapsedTime / animationDuration, 1);
      const newPercentage = Math.min(progress * targetPercentage, targetPercentage);
      setLoadingPercentage(newPercentage);

      if (progress >= 1) {
        clearInterval(loadingInterval);
      }
    }, 100);

    return () => {
      clearInterval(labelInterval);
      clearInterval(loadingInterval);
    };
  }, []);

  return (
    <div className="-ml-[1.7em] -mb-[0.375em]">
      <SudoButton
        id="button-generate-scenes"
        variant="tertiary"
        state="loading"
        loadingPercentage={loadingPercentage}
        loadingTransitionDuration={0.2} // Smooth transition between percentage updates
        disabled={true}
        onClick={onClick}
        leftIcon="/assets/AI-sparkle.svg"
      >
        {label}
      </SudoButton>
    </div>
  );
};

export default GenerateScenesLoaderButton;
